import { Pipe, PipeTransform } from '@angular/core';
import { LocalStorageService } from '@shared/services/local-storage/local-storage.service';
import { CultureEnum } from '@enums/culture.enum';

/*
 * Format decimal numbers (i.e. prices) depending on selected culture
 *   nl-NL use "," while en-GB use "."
 * Usage:
 *   value | formatDecimals:culture
 * Example:
 *   displayPrice = "512,30"
 *   selected culture = "en-GB"
 *   {{ displayPrice | formatDecimals:culture }}
 *   formats to: "512.30"
 */

@Pipe({
  name: 'formatDecimals'
})
export class FormatDecimalsPipe implements PipeTransform {
  private localStorageService = new LocalStorageService();

  transform(value: string, c?: string): string {
    const culture = this.localStorageService.getCulture();

    if (culture === CultureEnum.nlNL && value.indexOf('.') !== -1) {
      return value.replace('.', ',');
    }
    else if (culture === CultureEnum.enGB && value.indexOf(',') !== -1) {
      return value.replace(',', '.');
    }
    else {
      return value;
    }
  }
}
